// extracted by mini-css-extract-plugin
export default {"Basa":"#EAEBEC","order":"G5dbd51 undefined","calendar":"G3653e4 G4443bf G5e65f6 G96fe7d G3201e9","left":"G89f2db","right":"G5ca31f","infoLine":"G08b4e7"};